/** @file Handlers of the viewport table: frame, mode, snap, key, cancel, and `tool.<id>` for every tool. */
import { toolStore } from '../../stores/toolStore';
import type { ToolDef } from '../../stores/types';
import { TOOLS } from '../../tools.gen';
import type { ViewportRuntime } from './createViewportRuntime';

/** registerBindings needs a handler for each binding id (it throws otherwise). */
export function viewportHandlers(runtime: Pick<ViewportRuntime, 'frameSelection' | 'commitUnkeyed' | 'cancel'>): Record<string, () => void> {
  const tools: readonly ToolDef[] = TOOLS;
  return {
    'viewport.frameSelection': () => { runtime.frameSelection(); },
    'viewport.toggleMode': () => { toolStore.setState((s) => ({ mode: s.mode === 'setup' ? 'animate' : 'setup' })); },
    'viewport.toggleSnap': () => { toolStore.setState((s) => ({ snap: !s.snap })); },
    'viewport.key': () => { runtime.commitUnkeyed(); },
    'viewport.cancel': () => { runtime.cancel(); },
    ...Object.fromEntries(tools.map((t) => [`tool.${t.id}`, () => { toolStore.setState({ active: t.id }); }])),
  };
}
